module.exports = __webpack_public_path__ + "static/media/1010102.d205da29.jpg";